import React from 'react';
import logoImage from '../assets/logo.png';

interface User {
  name: string;
  email: string;
  picture?: string;
  [key: string]: any;
}

interface HeaderProps {
  user: User | null;
  onLogout: () => Promise<void>;
}

const Header: React.FC<HeaderProps> = ({ user, onLogout }) => {
  return (
    <header className="bg-white dark:bg-gray-800 shadow-sm z-10">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <img src={logoImage} alt="Logo" className="h-8 w-auto" />
          </div>
          
          <div className="flex flex-col items-center">
            <h1 className="text-xl font-bold text-gray-900 dark:text-white">Knowledge Management System (KMS)</h1>
            <a 
              href="https://www.qutec.it/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-xs text-blue-600 dark:text-blue-400 hover:underline"
            >
              powered by QuTec
            </a>
          </div>
          
          <div className="flex justify-end">
            {user ? (
              <div className="flex items-center space-x-4">
                <div className="flex items-center">
                  {user.picture && (
                    <img 
                      src={user.picture} 
                      alt={user.name} 
                      className="h-8 w-8 rounded-full mr-2"
                    />
                  )}
                  <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                    {user.name}
                  </span>
                </div>
                <button
                  onClick={() => onLogout()}
                  className="px-3 py-1 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
                >
                  Esci
                </button>
              </div>
            ) : (
              <span className="text-sm text-gray-500 dark:text-gray-400">Accesso non effettuato</span>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 